import { render, staticRenderFns } from "./TranslationsGroupFilter.vue?vue&type=template&id=1e3b08d5"
import script from "./TranslationsGroupFilter.vue?vue&type=script&lang=js"
export * from "./TranslationsGroupFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports